import React, { useState, useEffect, useRef } from "react";
import { Redirect, Link, withRouter } from "react-router-dom";
//Se importan los componentes a utilizar
import Login from "../../../components/Login/Login";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
//import Sesion from "../../../components/Login/Sesion";

import { ReactComponent as Logo_Header } from "../../../assets/img/ID_observadores.svg";
import { ReactComponent as Logo_Login } from "../../../assets/img/ID_Docs2.svg";
//Componentes de ant desig
import { Layout, Col, Row, Modal, Checkbox, Radio, Tooltip, Form } from "antd";
import { UserOutlined, InfoCircleFilled } from "@ant-design/icons";
import "./Login.scss";
import { getAccessTokenApi } from "../../../api/auth";
//import Carrusel from "../../../components/Carrusel/Carrusel";
import BlockLoader from "../../../components/Generals/Loader";
import moment from "moment";
//import Barchart from "../../../components/Login/Barchart";
//import { getEstadisticasLogin } from "../../../api/estadisticas";
import { emptyCache } from "../../../components/Generals/functions";
import LoginGrafica from "../../../components/Login/LoginGrafica";
import AvanceAcre from "../../../components/Login/AvanceAcre";
import LoginMapa from "../../../components/Login/LoginMapa";
import { getFechaCorteHomeLogin } from "../../../api/cruces";
import LoginPieChart from "../../../components/Login/LoginPieChart";
import LoginPieChartInf from "../../../components/Login/LoginPieChartInf";
import ayuda_grafica_barras from "../../../assets/img/Examples/ayuda_grafica_barras.gif";
import { getParamCaptcha } from "../../../api/others";

function LoginPrincipal(props) {
  const {
    history: {
      location: { pathname },
    },
  } = props;
  const [visibleSession, setVisibleSession] = useState(false);
  const [loader, setLoader] = useState({ loading: false, message: "" }); //Status para mostrar el loader
  const { Content } = Layout; //Se obtiene el componente hijo de Layout
  const isMounted = useRef(true);
  const [estadisticas, setEstadisticas] = useState({
    datosGrafica: [],
    idEstadoMaxAcre: 0,
    nombreEstadoMaxAcre: "",
    capacitadasMaxAcre: 0,
    acreditadasMaxAcre: 0,
    porcentajeMaxAcre: 0,
    abreviaturaMaxAcre: "",
    idEstadoMinAcre: 0,
    nombreEstadoMinAcre: "",
    capacitadasMinAcre: 0,
    acreditadasMinAcre: 0,
    porcentajeMinAcre: 0,
    abreviaturaMinAcre: "",
    datosEstatales: []
  });
  const [fechaCorteHomeLogin, setFechaCorteHomeLogin] = useState();
  const [nombreProceso, setNombreProceso] = useState("");
  const [form]  = Form.useForm();
  const [nacional, setNacional] = useState(true);
  const [datoEstatal, setDatoEstatal] = useState({});
  const [paramCaptcha, setParamCaptcha] = useState(0); //Para ver que captcha mostrar

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {

    emptyCache();
    getFechaCorteHomeLogin().then((res) => {
      if(isMounted.current) {
        setFechaCorteHomeLogin(res.data.fechaCorte);
        setNombreProceso(res.data.nombreProceso)
      }
    }).catch((error) => {
      console.log("Error en servicio web ", error);
      setFechaCorteHomeLogin(null);
      setNombreProceso("---");
    });

    getEstadisticasJson();

    getParamCaptcha().then((resC) => {

      if(isMounted.current) {

        /**
         * Valor utilizado para indicar si se activa el captcha de Google o el catcha de React
         * 0 = captcha google, 
         * 1 = captcha react
         */
        setParamCaptcha(resC.data.paramCaptcha);
      }

    }).catch((error) => {
      console.log("Error en servicio web ", error);
      setParamCaptcha(0);
    });

  }, []);

  function getEstadisticasJson() {
    //Definimos cabeceras para el llamado al json
    var myHeaders = new Headers();
    myHeaders.append("X-Content-Type-Options", "nosniff");
    myHeaders.append("X-Frame-Options", "deny");
    myHeaders.append("X-XSS-Protection", "1;mode=block");
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Content-Type", "text/plain");
    myHeaders.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
    var headers = {
        method: 'GET',
        headers: myHeaders
    };
    //Definimos la ruta donde se encuentra el json
    var origenJson = "/HomeLoginInterno/nacional.json";
    //Obtenemos el json
    fetch(origenJson, headers).then(resolve => {
        return resolve.json();
    }).then(info => {
        setEstadisticas(info);
    }).catch(error => {
        console.log("Ocurrió un error: ", error);
    });
  }

  //Se valida si tiene una sesión activa lo mande al home
  if (getAccessTokenApi()) {
    return <Redirect to="/admin/home" />;
  }

  const UltimaActualizacion = () => {
    if(fechaCorteHomeLogin === null) {
      return (
        <div style={{ fontSize: "12px" }}>
          Último corte: -- horas del --
        </div>
      );
    } else {
      return (
        <div style={{ fontSize: "12px" }}>
          Último corte: {moment(fechaCorteHomeLogin).format("HH:mm")} horas del {moment(fechaCorteHomeLogin).format("DD/MM/YYYY")}
        </div>
      );
    }
  };
  //Funciones para mostrar el modal
  const showModalSession = () => {
    setVisibleSession(true);
  };
  const handleOkSesion = (e) => {
    setVisibleSession(false);
  };

  const handleCancelSesion = (e) => {
    setVisibleSession(false);
  };

  const onChangeNacional = (e) => {
    if(form.getFieldValue("estado") !== undefined) {
      form.setFieldsValue({estado: undefined});
      setNacional(true);
    }
  };

  const formatPorcentaje = numOriginal => {
    var resultado = "";
    resultado = Number(numOriginal).toFixed(2);
    resultado.toString();
    return resultado;
  };

  const onChangeEstado = (e) => {
    setNacional(false);
    if(estadisticas.datosEstatales && estadisticas.datosEstatales.length > 0) {
      for(let i=0; i<estadisticas.datosEstatales.length; i++) {
        if(estadisticas.datosEstatales[i].idEstado === e.target.value) {
          setDatoEstatal(estadisticas.datosEstatales[i]);
          break;
        }
      }
    }
  };

  const TooltipSolicitudes = () => {
    return (
      <div style={{width: 210, fontSize: 10}}>
        <p>
          Las <span style={{color: "#FD8C8C"}}>solicitudes recibidas</span> representan 
          el <b>100% del avance</b> de cada entidad.
        </p>
        <p>
          Los porcentajes de avance de las solicitudes <span style={{color: "#2CC9D6"}}>validadas</span>,&nbsp;
          <span style={{color: "#A867EE"}}>capacitadas</span>, <span style={{color: "#DB2491"}}>acreditadas</span>, así como 
          los <span style={{color: "#9D9D9D"}}>otros estatus</span>, se calculan con respecto al 100% de solicitudes 
          recibidas por entidad.
        </p>
      </div>
    );
  };

  return (
    //Para mostrar el loader en el login
    <BlockLoader loading={loader.loading} message={loader.message}>
      <Modal
        open={visibleSession}
        onOk={handleOkSesion}
        onCancel={handleCancelSesion}
        footer={null}
        className="modalLoginRegistro"
      >
        <Login Logo={Logo_Login} setLoader={setLoader} paramCaptcha={paramCaptcha}/>
      </Modal>
      <Layout>
        {/**Se importa el header y se le envía el logo correspondiente */}
        <Header Logo={Logo_Header} />
        <Content className="content">
          {/**Contenido  */}
          <Row>
            <Row style={{minWidth: '100%', marginBottom: '10px'}}> 
              <Col span={12}>
                <div>
                  <h2 className="procesoHomeLogin">{nombreProceso}</h2>
                </div>
                <UltimaActualizacion />
              </Col>
              <Col span={12}>
                <div className="loginCiudadano">
                  <Link to={pathname} type="link" onClick={showModalSession}>
                    <UserOutlined /> Iniciar sesión
                  </Link>
                </div>
              </Col>
            </Row>
            <br />
          </Row>
          {/* Nuevo Home/Login */}
          <Row gutter={[10,20]}>
            <Col xs={24} md={4} style={{ paddingRight: 26 }} >
              <div className="card-menu-home-interno" style={{textAlign:"left"}}>

                <div className="encabezado_con_bb">
                  <b>Mostrar información</b>
                </div>
                
                <Row className="card-scroll">
                  <Col span={24}>
                    <Form form={form}>
                      <Row>
                        <Col span={24} className="encabezado_con_bb">
                          <span style={{ fontSize: 16 }}>Entidad</span>
                          <Form.Item style={{ marginBottom: 0 }} >
                            <Checkbox checked={nacional} onChange={onChangeNacional} className="ant-form-item-label" style={{ fontSize: 14 }}>
                              Nacional
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <Form.Item name="estado"> 
                            <Radio.Group onChange={onChangeEstado} aria-label="Seleccionar estado" style={{ display: "block" }}>
                              {estadisticas.datosGrafica.length > 0 &&
                                estadisticas.datosGrafica.map((item) => (
                                  
                                  <Radio className="ant-form-item-label" key={item.idEstado} value={item.idEstado} >
                                    {item.nombreEstado}                                   
                                  </Radio>
                                  
                                ))}
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </div>
            </Col>
            {nacional && (
              <>
              <Col xs={24} md={12}>
                <Row gutter={[0,30]} style={{paddingBottom: '15px'}}>
                  <Col span={24}>
                    <div className="card-menu-home-interno encabezadoGrafica" style={{minHeight:'250px'}}>
                      <b>&nbsp;Avance del registro de solicitudes de observadoras y observadores a nivel Nacional&nbsp;</b>
                      <Tooltip title={<TooltipSolicitudes />} overlayClassName="tool-back-blanco" placement="right">
                      <InfoCircleFilled  className="icon-info-login-interno"/>
                      </Tooltip>
                      <LoginGrafica datosGrafica={estadisticas.datosGrafica}/>
                      <Tooltip title={<img src={ayuda_grafica_barras} alt="ayuda" width={350} />}
                        placement="rightTop" overlayStyle={{ maxWidth: 800 }}
                      >
                        <p style={{fontSize:"12px", paddingLeft:"90px", width:"295px"}}>
                          ¿Cómo puedo consultar la gráfica? <InfoCircleFilled className="icon-info-login-interno"/>
                        </p>
                      </Tooltip>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <div className="card-menu-home-interno encabezadoGrafica">
                      <b>&nbsp;Mayor avance de acreditados por Entidad</b>
                      <AvanceAcre estadisticas={estadisticas} />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={8}>
                <div className="card-menu-home-interno encabezadoGrafica" style={{minHeight:'600px'}}>
                  <b>&nbsp;Total de acreditados por Entidad</b>
                  <LoginMapa datos={estadisticas.datosGrafica} nacional={true} />
                </div>
              </Col>
              </>
            )}
            {!nacional && (
              <>
              <Col xs={24} md={20}>
                <Row gutter={[0,10]}>
                  <Col xs={12} md={8}>
                    <div className="card-menu-home-interno card-menu-home-interno-rigth encabezadoGrafica h160">
                      <b>Solicitudes recibidas</b><br/><br/>
                      <Row style={{fontSize: 16}}>
                        <Col span={8}>Portal Público</Col>
                        <Col span={8}>JE</Col>
                        <Col span={8}>OPL</Col>
                        {/* <Col span={6}>Organización</Col> */}
                      </Row>
                      <Row className="solicitudesRec">
                        <Col span={8}>{datoEstatal.recPortal}</Col>
                        <Col span={8}>{datoEstatal.recJE}</Col>
                        <Col span={8}>{datoEstatal.recOPL}</Col>
                        {/* <Col span={6}>{datoEstatal.recOrg}</Col> */}
                      </Row>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="card-menu-home-interno card-menu-home-interno-rigth encabezadoGrafica h160">
                      <b>Solicitudes validadas</b><br/><br/>
                      <Row style={{fontSize: 16}}>
                        <Col span={24}>Por la JE</Col>
                      </Row>
                      <Row className="solicitudesVal">
                        <Col span={24}>{datoEstatal.validJE}</Col>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={12} md={5}>
                    <div className="card-menu-home-interno card-menu-home-interno-rigth encabezadoGrafica h160">
                      <b>Solicitudes capacitadas</b><br/><br/>
                      <Row style={{fontSize: 16}}>
                        <Col span={12}>Presencial / Distancia</Col>
                        <Col span={12}>Virtual</Col>
                      </Row>
                      <Row className="solicitudesCap">
                        <Col span={12}>{datoEstatal.capPres}</Col>
                        <Col span={12}>{datoEstatal.capVirtual}</Col>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={12} md={7}>
                    <div className="card-menu-home-interno encabezadoGrafica h160">
                      <b>Otros estatus de solicitudes</b><br/><br/>
                      <Row className="card-menu-home-interno-text-left">
                        <Col span={14}>Cancelada</Col>
                        <Col span={5} className="solicitudesEstatus1">{datoEstatal.canceladas}</Col>
                        <Col span={5} className="solicitudesEstatus2">{formatPorcentaje(datoEstatal.canceladasPorc)}%</Col>
                      </Row>
                      <Row className="card-menu-home-interno-text-left">
                        <Col span={14}>Declinada</Col>
                        <Col span={5} className="solicitudesEstatus1">{datoEstatal.declinadas}</Col>
                        <Col span={5} className="solicitudesEstatus2">{formatPorcentaje(datoEstatal.declinadasPorc)}%</Col>
                      </Row>
                      <Row className="card-menu-home-interno-text-left">
                        <Col span={14}>Denegada</Col>
                        <Col span={5} className="solicitudesEstatus1">{datoEstatal.denegadas}</Col>
                        <Col span={5} className="solicitudesEstatus2">{formatPorcentaje(datoEstatal.denegadasPorc)}%</Col>
                      </Row>
                      <Row className="card-menu-home-interno-text-left">
                        <Col span={14}>No completó los requisitos</Col>
                        <Col span={5} className="solicitudesEstatus1">{datoEstatal.noCompReq}</Col>
                        <Col span={5} className="solicitudesEstatus2">{formatPorcentaje(datoEstatal.noCompReqPorc)}%</Col>
                      </Row>
                      <Row className="card-menu-home-interno-text-left">
                        <Col span={14}>Registrado en otro sistema</Col>
                        <Col span={5} className="solicitudesEstatus1">{datoEstatal.regisOtroSist}</Col>
                        <Col span={5} className="solicitudesEstatus2">{formatPorcentaje(datoEstatal.regisOtroSistPorc)}%</Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={8}>
                    <div className="card-menu-home-interno card-menu-home-interno-rigth card-menu-home-interno-top encabezadoGrafica h425">
                      <b>Detalle de solicitudes acreditadas</b><br/>
                      <span>Total de solicitudes acreditadas: {datoEstatal.acreditados}</span>
                      <LoginPieChart datos={datoEstatal} />
                    </div>
                  </Col>
                  <Col xs={12} md={9}>
                    <div className="card-menu-home-interno card-menu-home-interno-rigth card-menu-home-interno-top encabezadoGrafica h425">
                      <b>Detalle de informes</b><br/>
                      <span>Total de informes: {datoEstatal.infEsperados}</span>
                      <LoginPieChartInf datos={datoEstatal} />
                    </div>
                  </Col>
                  <Col xs={12} md={7}>
                    <div className="card-menu-home-interno card-menu-home-interno-top encabezadoGrafica h425">
                      <b>Total de acreditados por Entidad</b>
                      <LoginMapa datos={datoEstatal} nacional={false}/>
                    </div>
                  </Col>
                </Row>
              </Col>
              </>
            )}
          </Row>
        </Content>
        {/**Footer con la versión del sistema */}
        <Footer version="Versión 4.0" anio="2023" />
      </Layout>
    </BlockLoader>
  );
}

const FormLoginPrincipal = LoginPrincipal;
export default withRouter(FormLoginPrincipal);
